function tabbedContent() {
  return {
    states: [],
    selected: '0',
  };
}

(window as any).tabbedContent = tabbedContent;
